export default {

    // Overall app related state…
    booting: true, // Is the app currently booting up?

    // - - - - - - - - - - - - - - - -

    // Nav open/closed state…
    // The Nav webview is the sole owner of this value (plan 2026-07-15). Persisted so a
    // native- or user-opened nav survives a relaunch; hosts reflect it, they don't own it.
    navOpen: true,

    // - - - - - - - - - - - - - - - -

    // Pane related state…
    currentPaneId: null,
    prevPaneId: null, // Deprecated in favour of the last `openedPaneIds`.
    openedPaneIds: [],

    // - - - - - - - - - - - - - - - -

    // Pane options related state…
    paneOptionsComponents: {}, // Value might look like `{ 'PANE_OPTIONS_1_ID' : { 'open': true }, 'PANE_OPTIONS_2_ID' : { 'open': false } }`.

    // - - - - - - - - - - - - - - - -

    // Pane option related state…
    currentPrimaryPaneOptionComponentId: null,

    // - - - - - - - - - - - - - - - -

    // Map filter related state…
    currentMapFilterCode: null,
    openedMapFilterCodes: [],
};


